import { Button, Col, message, Row, Tag } from "antd";
import React, { useContext, useEffect } from "react";
import PatientAssessmentReviewSummary from "../../DailyReviewSummaries/PatientAssessment/PatientAssessmentReviewSummary";
import { RespiratoryReviewContext } from "./RespiratoryTherapistReviewProvider";
import { getRespiratoryReviewAPI } from "../../../../services/respiratory.services";
import DrClinicalImpressionSummary from "../../InspectionSummaries/ClinicalImpressionSummary/DrClinicalImpressionSummary";
import RespiratoryTreatmentPlanSummary from "../../InspectionSummaries/TreatmentPlan/RespiratoryTreatmentPlanSummary";
import { checkEmpty } from "../../../../helpers/utility";
import dayjs from "dayjs";
import EditIcon from "../../../ui/EditIcon";
import btnStyles from "../../../../styles/Custom/Button.module.css";
import "../../summary.css";
import "../../Doctor/DailyReview/DailyReview.css";

const RespiratoryTherapistReviewSummary = ({
  editId,
  dailyRefresh,
  isActive = false,
  onEdit,
  canEdit = false,
}) => {
  const { formData, setFormData } = useContext(RespiratoryReviewContext);
  const openEdit = async () => {
    if (editId) {
      try {
        const response = await getRespiratoryReviewAPI(editId);
        setFormData(response.data.data);
      } catch (error) {
        console.log(`Error: ${error}`);
        message.error("Unable to Fetch Data");
      }
    }
  };

  useEffect(() => {
    openEdit();
  }, [editId, dailyRefresh]);

  return (
    <Row className="summaries daily-review-summaries" gutter={[16, 16]}>
      <Col span={24}>
        <div className="daily-review-meta-bar">
          {(formData?.submitted_by_first_name ||
            formData?.submitted_by_last_name) && (
            <Tag className="daily-review-meta-tag--submitted">
              Submitted by: {formData?.submitted_by_first_name || ""}{" "}
              {formData?.submitted_by_last_name || ""}
            </Tag>
          )}
          <div className="daily-review-meta-bottom">
            {formData?.updated_at && (
              <Tag className="daily-review-meta-tag--updated">
                Updated at:{" "}
                {dayjs(formData?.updated_at).format("DD/MM/YYYY hh:mm A")}
              </Tag>
            )}
            {isActive && (
              <div className="daily-review-meta-actions--mobile">
                <Button
                  type="primary"
                  onClick={onEdit}
                  className={`${btnStyles.lgBtn} inv-btn`}
                  disabled={!canEdit}
                  style={{ fontWeight: 500 }}
                >
                  <EditIcon />
                  Edit
                </Button>
              </div>
            )}
          </div>
        </div>
      </Col>
      <Col xs={24} sm={24} md={24} lg={12} xl={12} xxl={12}>
        {checkEmpty(formData?.clinical_diagnosis) && (
          <DrClinicalImpressionSummary context={RespiratoryReviewContext} />
        )}
        {checkEmpty(formData?.patient_assessment) && (
          <PatientAssessmentReviewSummary formData={formData} />
        )}
      </Col>
      <Col xs={24} sm={24} md={24} lg={12} xl={12} xxl={12}>
        {checkEmpty(formData?.treatment_plan) && (
          <RespiratoryTreatmentPlanSummary
            context={RespiratoryReviewContext}
          />
        )}
      </Col>
    </Row>
  );
};

export default RespiratoryTherapistReviewSummary;
